import React from "react";
import { Box, Typography, useMediaQuery, useTheme } from "@mui/material";

const Subtitle = ({ children }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isTablet = useMediaQuery("(min-width: 600px) and (max-width: 900px)");
  
  return (
    <p
      style={{
        fontWeight: 400,
        fontSize: isMobile ? "11px" : isTablet ? "12px" : "14px",
        marginBottom: isMobile ? "16px" : isTablet ? "10px" : "30px",
        color: "#686866",
        lineHeight: 1.5,
      }}
    >
      {children}
    </p>
  );
};

export default Subtitle;